module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_GA-a2678d9c1466f41428cc5fae924700aa.svg";